import React, { Component } from 'react';
import { connect } from 'react-redux';

import InteractiveCircleViews from './views';

import { selectHighlightColor } from 'PipeRouter';


class InteractiveCircle extends Component {
  constructor(props) {
    super(props);
  }

  handleOnClick = event => {
    const { selectedHighlight, selectHighlightColor } = this.props;
    const target = event.currentTarget.name;
    let markerId;

    if (target === 'marker') {
      markerId = event.currentTarget.value;
    }

    if (!target || target === 'svg') {
      markerId = event.currentTarget.previousElementSibling.value;
    }

    if (!markerId) {
      logger.warn('InteractiveCircle -- missing markerId', { node: event.currentTarget.outerHTML });
      return;
    }

    selectHighlightColor(markerId, selectedHighlight);
  };

  render() {
    const viewProps = {
      ...this.props,
      handleOnClick: this.handleOnClick
    };

    return <InteractiveCircleViews { ...viewProps } />;
  }
};


function mapStateToProps(state) {
  return {
    selectedHighlight: state.selectedHighlight
  };
}

export default connect(mapStateToProps, {
  selectHighlightColor
})(InteractiveCircle);
